import { createAsyncThunk } from '@reduxjs/toolkit';
import { useServices } from '../../apis';

export const login = (token: any) =>
	createAsyncThunk('user/login', async () => {
		const { userService } = useServices();
		// console.log(token)

		return await userService.login(token);
	});
